import { Box } from "@mui/system";

import { Button, Typography } from "@mui/joy";
import { Helmet } from "react-helmet";
import { Outlet, useParams } from "react-router-dom";
import { heightWithToolbar } from "../global";
import { SeasonsDatagrid } from "../hooks/seasonsDatagrid/seasonsDatagrid";
import { useMyMember } from "../redux/member/memberHooks";
import { useDispatch } from "react-redux";
import { setFormOpen } from "../reducers/rhapsody";
import { usePro } from "../hooks/usePro/usePro";
import { proEnabled } from "../constants";

export default function Seasons() {
  const param = useParams();
  const pro = usePro();
  const dispatch = useDispatch();

  if (param.emailID) return <Outlet />;

  return (
    <>
      <Box
        sx={{
          p: 2,
          display: "flex",
          gap: 2,
          flexDirection: "column",
          justifyContent: "stretch",
          margin: "auto",
          maxWidth: 1600,
          width: "100vw",
          position: "relative",
          flex: 1,
          height: heightWithToolbar,
        }}
      >
        <Helmet>
          <title>Rhapsody | Seasons</title>
        </Helmet>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography level="h6">Seasons</Typography>
          {proEnabled ? (
            <Button
              onClick={() =>
                dispatch(setFormOpen({ isOpen: true, formID: "season" }))
              }
              size="sm"
              color="info"
            >
              + New Season
            </Button>
          ) : (
            []
          )}
        </Box>
        <Box
          sx={{
            display: "flex",
            flexGrow: 1,
            height: 0,
            minHeight: "auto",
          }}
        >
          <SeasonsDatagrid />
        </Box>
      </Box>
    </>
  );
}
